import { useState, useEffect } from 'react';

/**
 * Devuelve true cuando la pantalla es angosta (celular).
 * Se usa para colapsar a una sola columna las vistas que en escritorio
 * van a dos columnas, ya que con estilos en linea no se pueden usar
 * media queries de CSS.
 */
export function useIsMobile(maxWidth = 900) {
  const [esMovil, setEsMovil] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= maxWidth : false
  );

  useEffect(() => {
    const alRedimensionar = () => setEsMovil(window.innerWidth <= maxWidth);
    window.addEventListener('resize', alRedimensionar);
    alRedimensionar();
    return () => window.removeEventListener('resize', alRedimensionar);
  }, [maxWidth]);

  return esMovil;
}

export default useIsMobile;
